import { OAuthStorage } from "angular-oauth2-oidc";

export function localSessionOAuthStorageFactory() : OAuthStorage {
    return localStorage
}